import FiltersManager from './FiltersManager';
export default FiltersManager;
